import React from "react";

import Container from 'react-bootstrap/Container';

import "./AboutHattie.scss";

const educationItems = [
    "Truman State University BSN 2004",
    "University of Missouri St Louis MSN 2012",
    "Liberty University Post Graduate Certification 2022",
    "American Association of Nurse Practitioners, Family Nurses Practitioner 2012",
    "American Nurses Credentialing Center,  Psychiatric Mental Health Nurse Practitioner 2022",
];

export default function AboutHattie() {
    return (
        <section className="about-hattie-section">
            <Container>
                <div className="about-hattie-header">
                    <h2 className="about-hattie-name">Hattie DeBord</h2>
                    <p className="about-hattie-credentials">MSN, APRN, PMHNP-BC, FNP-C</p>
                </div>

                <div className="about-hattie-main">
                    <div className="about-hattie-content">
                        <p className="about-hattie-body">
                            Hattie DeBord is a board-certified Family Nurse practitioner and Psychiatric Nurse practitioner who is dedicated, compassionate, and diligent. She takes pride in serving children, adolescents and adults with their mental health and primary care needs. Ms. DeBord graduated with Honors with her master's in nursing at University of Missouri St Louis in 2012 and has a post master's certificate from Liberty University as a psychiatric nurse practitioner. She holds a bachelor's degree from Truman State University. Hattie is an Army veteran that served for three years and deployed to Operation Iraqi Freedom.
                        </p>
                        <p className="about-hattie-body">
                            Patients see her for a variety of reasons, including pediatric consultations, postpartum depression, depression, anxiety, mood disorders, ADHD and eating disorders.  She also specializes in treating multiple chronic medical conditions such as diabetes, hypertension, hyperlipidemia, and asthma.  Ms. DeBord treats a wide range of conditions, and she is eager to help the wider community receive the care they deserve.  She believes that  healing the mind can also heal the body and enjoys treating the whole patient.  She is dedicated to listening to the patients' specific needs and tailoring a plan of care for each individual.
                        </p>

                        <div className="about-hattie-education">
                            <h3 className="about-hattie-education__title">Education, Certifications &amp; Training</h3>
                            <ul className="about-hattie-education__list">
                                {educationItems.map((item) => (
                                    <li key={item}>{item}</li>
                                ))}
                            </ul>
                        </div>
                    </div>

                    <div className="about-hattie-photo">
                        <div className="about-hattie-photo-frame">
                            <img src="../../hattie.png" alt="Hattie DeBord" />
                        </div>
                    </div>
                </div>
            </Container>
        </section>
    );
}
